module.exports = __webpack_public_path__ + "images/emoji/vibration_mode.888c6e9e71a871147362.png";